<template>
  <div class="video-content">
    <div class="bar-list">
      <ul>
        <li v-for="(item,i) in video_list" :key="i" :class="{'select-bar': i == video_s_index}" @click="bar_select_click(i)">{{item}}</li>
      </ul>
    </div>
    <div class="video-container">
       <!-- 视频上传组件 -->
       <DoctorPage v-if="video_s_index == 0"/>
       <Orderinfo v-else-if="video_s_index == 1"/>
       <UesrManage v-else/>
    </div>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, onMounted,  ref, onBeforeMount} from "vue";
import DoctorPage from '@/components/video/doctorPage.vue'
import Orderinfo from '@/components/video/orderinfo.vue'
import UesrManage from '@/components/video/uesrManage.vue'
const video_list = ref(["医师管理", "订单查询", "业务员管理"]);
const video_s_index = ref(0)
const bar_select_click = (i) => {
       video_s_index.value = i
}
</script>
<style scoped>
.bar-list{
       border-bottom: 1px solid #ddd;
}
.bar-list>ul{
       display: flex;
       align-items: center;
       justify-content: space-between;
       font-size: 18px;
       padding: 15px 55px;
       margin-top: 15px;
}
.bar-list>ul>li{
       cursor: pointer;
       text-underline-offset: 8px;
}
.select-bar{
       color: rgba(22, 22, 245, 0.3);
       text-decoration-color: rgba(22, 22, 245, 0.3);
       text-underline-offset: 8px;
       text-decoration: underline;
}
.video-container{
       background: rgba(243, 243, 245, 0.3);
       width: 100%;
       height: 86vh;
       position: relative;
       padding-top: 22px;
}
</style>